import React from "react";
import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 24, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ children, testId }) => (
  <div
    data-testid={testId}
    className="text-[11px] tracking-[0.35em] uppercase text-livon-muted mb-8 flex items-center gap-4 font-medium"
  >
    <span className="h-px w-10 bg-livon-muted/50" />
    {children}
  </div>
);
